/**
 * 데모 모드 상태 (기기 없이 합성 데이터로 앱 체험)
 *
 * 모듈 단일 플래그 + 구독. React 에서는 useSyncExternalStore 로 구독한다.
 * utils 계층이므로 Store 를 import 하지 않는다.
 */

let enabled = false;
const listeners = new Set<() => void>();

export function isDemoMode(): boolean {
  return enabled;
}

export function setDemoMode(next: boolean): void {
  if (enabled === next) return;
  enabled = next;
  listeners.forEach((listener) => listener());
}

export function subscribeDemoMode(listener: () => void): () => void {
  listeners.add(listener);
  return () => {
    listeners.delete(listener);
  };
}
